import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from "react";
import DatePicker from "react-datepicker";
import Select from "../common/selectcustom";
//import ChartColumn from './../../components/chart/column';
import ProgressChart from "../chart/progresschart.js";
import ReportCreate from "../chart/reportCreator";
import Piechart from "../chart/piechart.js";
import moment from "moment";
import RenderButton from "../common/button";
import BranchContext from "../context/branch";
import { getCompareBU,GetYear,getSumaryByBU,getgroupequipment } from "../../services/fire";
import { getMonth } from "../../services/month";
import ScrollToTop from "../common/ScrollToTop";
import Modeldasboard from "../dashboard/modaldashboard";
import { toast } from "react-toastify";
//import {getUserCurrent,getUserCurrentbyArea} from './../../services/facescan';


const Reportregister = (props) => {
  const [Id, setId] = useState(props.match.params.id);
  const { currentBranch } = useContext(BranchContext);
  const [startDate, setStartDate] = useState(new Date());
  const [isOpen, setisOpen] = useState(false);
  const [value, setValue] = useState(14);
  const [total, setTotal] = useState(0);
  const [id, setid] = useState(0);
  const [hour, sethour] = useState(0);
  const [amountcompare, setAmountcompare] = useState([]);
  const [devicelist, setdevicelist] = useState([]);
  const [scanlist, setscanlist] = useState([]);
  const [dataall, setDataall] = useState({});
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState({});
  const [powerdata, setpowerdata] = useState({});
  const [nonpowerdata, setnonpowerdata] = useState({});
  const [groupdata, setgroupdata] = useState({});
  const [grouplocation, setgrouplocation] = useState([]);
  const [data4, setData4] = useState([]);

  const [chartdatapermit, setchartdatapermit] = useState([]);

  const [chartdatahour, setchartchartdatahour] = useState([]);
  const [graphtype, setgraphtype] = useState("bar");
  const [devicename, setdevicename] = useState("");
  const [ip1, setip1] = useState(0);
  const [dap, setdap] = useState(0);
  const [ip2, setip2] = useState(0);
  const [bitec, setbitec] = useState(0);
  const [showonscroll, setshowonscroll] = useState(false);
  const [onprocess, setonprocess] = useState(false);
  const [pageSize, setPageSize] = useState(2000);
  const [statusId, setstatusid] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const [comparebulist, setcomparebulist] = useState([]);

  const [yearlist, setyearlist] = useState([]);
  const [monthlist, setmonthlist] = useState([]);
  const [power, setpower] = useState([]);
  const [nonpower, setnonpower] = useState([]);
  const [areadap, setareadap] = useState([]);
  const [areabitec, setareabitec] = useState([]);
  const [yearid, setyearid] = useState("2023");
  const [month, setmonth] = useState("01");
 
useEffect(() => {
    if (!currentBranch) return;



    const loadData = async () => {

      const { data: result } = await GetYear()

        if (result.status ==="success") {

          setyearlist(result.data.list);

        }else if(result.status === "error" && result.message === "invalid token"){
        const urlGoBack = "logout";
        setTimeout(props.history.replace(urlGoBack), 1000);
      }
    };
    loadData();
  }, [currentBranch]);


  useEffect(() => {
    if (!currentBranch) return;
  
    const loadData = async () => {
  
      const result = await getMonth()
     // console.log(result)
        if (result) {
  //console.log(result)
          setmonthlist(result);
  
        }
    };
    loadData();
  }, [currentBranch]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getgroupequipment(yearid, month,hour)

        if (result) {
//console.log("data1",result)
          setgrouplocation(result);

        }
    };
    loadData();
  }, [currentBranch,yearid,month,hour]);
  


  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getSumaryByBU(yearid, month,2)

        if (result) {

          setpower(result);

        }
    };
    loadData();
  }, [currentBranch,yearid,month]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {

      const { data: result } = await getSumaryByBU(yearid, month,1)

        if (result) {

          setnonpower(result);

        }
    };
    loadData();
  }, [currentBranch,yearid,month]);



  //  useEffect(() => {
  //   if (!currentBranch) return;

  //   const loadData = async () => {

  //     const { data: result } = await getUserCurrent()

  //       if (result.status === "success") {
  //         setTotal(result.data.total);
  //         setip1(result.data.IP1);
  //         setip2(result.data.IP2)
  //         setdap(result.data.DAP)
  //         setbitec(result.data.BITEC)

  //       }else if (result.status ==="error") {

  //       }
  //   };
  //   loadData();
  // }, [currentBranch, Id]);

  useEffect(() => {
    if (!currentBranch) return;

    const loadData = async () => {
      const { data: result } = await getCompareBU(yearid, month);

      if (result.status === "success") {
        setcomparebulist(result.data.list);
      }
    };
    loadData();
  }, [currentBranch, yearid, month]);

  const handleyearChange = (event) => {
    setPageNumber(1);
    setyearid(event.currentTarget.value);  
   
   
   }
   const handlemonthChange = (event) => {
    setPageNumber(1);
    setmonth(event.currentTarget.value);  
   
   
   }

   const handleCancleSubmit = () => {

    setisOpen(false);
  }

  
  useEffect(() => {
    if (!grouplocation || !currentBranch) return;
    
    const chart = () => {
      let label = [];
      let inspec = [];
      let noninspec = [];
      let amount = [];
      let normal = []
      let defect =[]
      for (const dataObj of grouplocation) {
        label.push(dataObj.Equipment_name);
        inspec.push(parseInt(dataObj.inspec));
        noninspec.push(parseInt(dataObj.noninspec));
        amount.push(parseInt(dataObj.amount));
        normal.push(parseInt(dataObj.good));
        defect.push(parseInt(dataObj.defect));
      }
      const data =
      {
        series: [        
          { name: "ปกติ", data:normal },
          { name: "ชำรุด", data: defect },
          { name: "ยังไม่ตรวจ", data: noninspec },
        ],
        dataLabels: {
        
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },
        yLabels: label,
        headers:
        "พื้นที่ " + hour,
        type: "bar",
        stacked: true,
      };
     
  setgroupdata(data);
    };
    chart();
  }, [grouplocation, currentBranch]);

   //console.log("ffff",grouplocation)
  // console.log("eeee",nonpower)
  useEffect(() => {
    if (!power || !currentBranch) return;

    const chart = () => {
      let label = [];
      let inspec = [];
      let noninspec = [];
      let amount = [];
      let normal = []
      let defect =[]
      for (const dataObj of power) {
        label.push(dataObj.name);
        inspec.push(parseInt(dataObj.inspec));
        noninspec.push(parseInt(dataObj.noninspec));
        amount.push(parseInt(dataObj.amount));
        normal.push(parseInt(dataObj.good));
        defect.push(parseInt(dataObj.defect));
      }
      const data =
      {
        series: [        
          { name: "ปกติ", data:normal },
          { name: "ชำรุด", data: defect },
          { name: "ยังไม่ตรวจ", data: noninspec },
        ],
        dataLabels: {
        
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },
        yLabels: label,
        headers:
          "อุปกรณ์ทั้งหมด กลุ่ม Power" ,
        type: "bar",
        stacked: true,
      };
  setpowerdata(data);
    };
    chart();
  }, [power, currentBranch]);



  //console.log(power)

  useEffect(() => {
    if (!nonpower || !currentBranch) return;

    const chart = () => {
      let label = [];
      let inspec = [];
      let noninspec = [];
      let amount = [];
      let normal = []
      let defect =[]
      for (const dataObj of nonpower) {
        label.push(dataObj.name);
        inspec.push(parseInt(dataObj.inspec));
        noninspec.push(parseInt(dataObj.noninspec));
        amount.push(parseInt(dataObj.amount));
        normal.push(parseInt(dataObj.good));
        defect.push(parseInt(dataObj.defect));
      }
      const data =
      {
        series: [        
          { name: "ปกติ", data:normal },
          { name: "ชำรุด", data: defect },
          { name: "ยังไม่ตรวจ", data: noninspec },
        ],
        dataLabels: {
        
          formatter: function (val, opts) {
              return opts.w.config.series[opts.seriesIndex]
          },
        },
        yLabels: label,
        headers:
          "อุปกรณ์ทั้งหมด กลุ่ม non Power" ,
        type: "bar",
        stacked: true,
      };
      //console.log("aaa",data)
  setnonpowerdata(data);
    };
    chart();
  }, [nonpower, currentBranch]);
  
  useEffect(() => {
    if (!comparebulist || !currentBranch) return;
    const chart = () => {
      let AmountA = [];
      for (const dataObj of comparebulist) {
        AmountA.push(parseInt(dataObj.amount));
      }
      const data = {
        series: [AmountA],
        yLabels: ["Pulp&Paper", "Power"],
        headers: "จำนวนอุปกรณ์ทั้งหมด)",
        type: "pie",
        stacked: true,
      };
      setData4(data);
    };
    chart();
  }, [comparebulist, currentBranch]);

  useEffect(() => {
    if (!comparebulist || !currentBranch) return;
    if (comparebulist === undefined) return;

    const chart = () => {
      let AmountA = [];
      if (comparebulist && comparebulist.length > 0) {
        AmountA.push(parseInt(comparebulist[0].noninspec));
        AmountA.push(parseInt(comparebulist[0].good));
        AmountA.push(parseInt(comparebulist[0].defect));
      }
      const data = {
        series: [AmountA],
        yLabels: ["ยังไม่ตรวจ", "ปกติ", "ชำรุด"],
        headers: "จำนวนอุปกรณ์)",
        type: "pie",
        stacked: true,
      };
      setData1(data);
    };
    chart();
  }, [comparebulist, currentBranch]);

  useEffect(() => {
    if (!comparebulist || !currentBranch) return;
    if (comparebulist === undefined) return;

    const chart = () => {
      let AmountA = [];
      if (comparebulist && comparebulist.length > 1) {
        AmountA.push(parseInt(comparebulist[1].noninspec));
        AmountA.push(parseInt(comparebulist[1].good));
        AmountA.push(parseInt(comparebulist[1].defect));
      }
      const data = {
        series: [AmountA],
        yLabels: ["ยังไม่ตรวจ", "ปกติ", "ชำรุด"],
        headers: "จำนวนอุปกรณ์)",
        type: "pie",
        stacked: true,
      };
      setData2(data);
    };
    chart();
  }, [comparebulist, currentBranch]);

  const chartopions = {
    theme: {
      mode: "light",
      palette: "palette1",
      monochrome: {
        enabled: false,
        color: "#255aee",
        shadeTo: "light",
        shadeIntensity: 0.65,
      },
    },
    dataLabels: {
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex];
      },
    },
  };

  const handleonClick = (hour, Id) => {
    //console.log("Test",hour, Id)
    setPageSize(1);
    setid(Id);
    sethour(hour);
    setisOpen(true)
    

  };

  if (
    !currentBranch ||
    data4.series === undefined ||
    data1.series === undefined ||
    data2.series === undefined ||
    (data4 && data4.series[0].length === 0) ||
    (data1 && data1.series[0].length === 0) ||
    (data2 && data2.series[0].length === 0)
  ) {
    return <></>;
  }
  return (




    <div className=" container-fluid">
      <div className="m-1 d-flex justify-content-center">
        <span
          className="badge badge-pill badge-info"
          style={{ fontSize: "16px" }}
        >
          Dashboard
        </span>
      </div>
      <div className="row">
      <Modeldasboard
               isOpen={isOpen}
               list={groupdata}
               onCancel={handleCancleSubmit}           
               size="xl"
               aria-labelledby="contained-modal-title-vcenter"         
               Year= {yearid}
               Month={month}
               Location ={hour}
            />

     
      <div className="col-lg-3  col-sm-4 col-xs-12">
            <div className="form-group">      
         
            <Select
                label="ปี"
                data={yearlist}
                value={yearid}
                textProperty="name"
                valueProperty="_id"
                onChange={handleyearChange}
              />

             
            </div>
          </div>
          <div className="col-lg-3  col-sm-4 col-xs-12">
            <div className="form-group">
        
       

            <Select
                label="เดือน"
                data={monthlist}
                value={month}
                textProperty="name"
                valueProperty="_id"
                onChange={handlemonthChange}
              />

             
            </div>
          </div>
          </div>
      <div>
        <div className="row">
          <div className="col-sm-4 col-xs-12">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">
                  จำนวนอุปกรณ์ ภาพรวม/แยกตามกลุ่มธุรกิจ
                </div>
                <div className="card-body text-center">
                  {data4 && data4 !== undefined && (
                    <Piechart
                      labels={data4.yLabels}
                      Datachart={data4.series[0]}
                      chartOptions={chartopions}

                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-4 col-xs-12">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">{"Pulp&Paper"}</div>
                <div className="card-body text-center">
                  {data1 && data1 !== undefined && (
                    <Piechart
                      labels={data1.yLabels}
                      Datachart={data1.series[0]}
                      chartOptions={chartopions}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-4 col-xs-12">
            <div className="mt-1">
              <div className="card">
                <div className="card-header text-center">{"Power"}</div>
                <div className="card-body text-center">
                  {data2 && data2 !== undefined && (
                    <Piechart
                      labels={data2.yLabels}
                      Datachart={data2.series[0]}
                      chartOptions={chartopions}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        
        <div className="col-12">
            <div className="mt-1">
            {powerdata.series !== undefined && 
            <ReportCreate
            data={powerdata}
            type={graphtype} 
            colors ={['#0FF54A', '#F63809', '#F6D209']}
            stacked ="true"     
            labelposition="top"
           
            onclick={handleonClick}
          />}
            </div>
          </div>
          <div className="col-12">
            <div className="mt-1">
            {nonpowerdata.series !== undefined && 
            <ReportCreate
            data={nonpowerdata}
            type={graphtype} 
            colors ={['#0FF54A', '#F63809', '#F6D209']}
            stacked ="true"     
            labelposition="top"
           
            onclick={handleonClick}
          />}
            </div>
          </div>
        <ScrollToTop />
      </div>
    </div>
  );
};

export default Reportregister;
